import React from 'react';
import { motion } from 'framer-motion';
export function CostOfInaction() {
  const rows = [{
    sin: 'Tardes enteras fallando recetas por tu cuenta',
    costo: 'Horas de tu vida perdidas que no vuelven'
  }, {
    sin: 'Insumos caros arruinados por mala temperatura',
    costo: 'Dinero tirado directamente a la basura'
  }, {
    sin: 'Ofrecer los mismos productos saturados de siempre',
    costo: 'Competir por precio bajo y ganar centavos'
  }, {
    sin: 'Miedo a cobrar mal por falta de estructura',
    costo: 'Trabajar gratis y terminar frustrada'
  }];
  return <section className="py-12 px-6 bg-brand-cream" data-id="element-36">
      <div className="max-w-4xl mx-auto" data-id="element-37">
        <div className="text-center mb-8" data-id="element-38">
          <h2 className="text-3xl font-serif font-bold text-brand-choco-deep" data-id="element-39">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="bg-white rounded-2xl overflow-hidden shadow-sm border border-brand-burgundy/20" data-id="element-40">
          <div className="grid grid-cols-2 bg-brand-burgundy/5 border-b border-brand-burgundy/10" data-id="element-41">
            <div className="p-4 md:p-6 font-bold text-brand-choco-deep text-center" data-id="element-42">
              Sin MegaPack
            </div>
            <div className="p-4 md:p-6 font-bold text-brand-burgundy text-center border-l border-brand-burgundy/10" data-id="element-43">
              Costo Real
            </div>
          </div>

          <div className="divide-y divide-brand-choco/5" data-id="element-44">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-2 hover:bg-brand-cream/20 transition-colors" data-id="element-45">
                <div className="p-4 md:p-6 text-brand-choco/80 text-sm md:text-base" data-id="element-46">
                  {row.sin}
                </div>
                <div className="p-4 md:p-6 text-brand-choco-deep font-medium text-sm md:text-base border-l border-brand-choco/5" data-id="element-47">
                  {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center mt-8" data-id="element-48">
          <p className="text-2xl font-serif italic text-brand-choco-deep font-semibold" data-id="element-49">
            El próximo fin de semana puede ser diferente.
          </p>
        </div>
      </div>
    </section>;
}